import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import PageContainer from '../../components/container/PageContainer';

export const ErrorPublic = () => (
  <PageContainer title="Error" description="this is Error page">
    <Box
      display="flex"
      flexDirection="column"
      height="100vh"
      textAlign="center"
      justifyContent="center"
      sx={{ backgroundColor: '#e4f5ff' }}
    >
      <Container maxWidth="md">
        <Typography
          align="center"
          variant="h4"
          sx={{
            pt: 1,
            pb: 3,
            color: (theme) =>
              `${theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.87)'}`,
          }}
        >
          This url is not available.
        </Typography>
      </Container>
    </Box>
  </PageContainer>
);

export default Error;
